import { type MouseEvent, useState } from 'react'
import * as S from './DesktopAppSection.styles'
import { useOneLinkUrl } from 'hooks/useOneLinkUrl'
import { ReactComponent as AppStoreBadge } from 'images/homePage/storeBadges/app-store.svg'
import AppQrPopup from '../AppQrPopup/AppQrPopup'
import {
  type CtaLink,
  MULTI_PRODUCT_APP_ONELINK,
  MULTI_PRODUCT_APP_PHONE_IMAGE,
  MULTI_PRODUCT_NAV_STATE,
  MULTI_PRODUCT_APP_SCREEN_VIDEO,
  MULTI_PRODUCT_VIDEO_FOLDER,
} from '../../multiProductHomePage.consts'

type Props = {
  title: string
  subtitle: string
  download: CtaLink
  appStoreBadgeLabel: string
  shouldShowQrCode: boolean
}

export default function DesktopAppSection({
  title,
  subtitle,
  download,
  appStoreBadgeLabel,
  shouldShowQrCode,
}: Props) {
  const oneLinkUrl = useOneLinkUrl(MULTI_PRODUCT_APP_ONELINK, !shouldShowQrCode)
  const [isQrPopupOpen, setIsQrPopupOpen] = useState(false)

  const onAppStoreBadgeClick = (event: MouseEvent<HTMLElement>) => {
    download.onClick(event)
    setIsQrPopupOpen(true)
  }

  return (
    <S.Container data-testid="multi-product-app">
      <S.Mockup>
        <S.Phone>
          <S.PhoneVideo
            cldId={MULTI_PRODUCT_APP_SCREEN_VIDEO}
            folder={MULTI_PRODUCT_VIDEO_FOLDER}
            cldWidth={450}
            name="App Screen"
            type="Video"
          />
          <S.PhoneImage
            src={MULTI_PRODUCT_APP_PHONE_IMAGE.src}
            srcSet={MULTI_PRODUCT_APP_PHONE_IMAGE.srcSet}
            sizes={MULTI_PRODUCT_APP_PHONE_IMAGE.sizes}
            width={MULTI_PRODUCT_APP_PHONE_IMAGE.width}
            height={MULTI_PRODUCT_APP_PHONE_IMAGE.height}
            loading="lazy"
            alt=""
          />
        </S.Phone>
      </S.Mockup>
      <S.Content>
        <S.TextBlock>
          <S.Title>{title}</S.Title>
          <S.Subtitle>{subtitle}</S.Subtitle>
        </S.TextBlock>
        {shouldShowQrCode ? (
          <S.AppStoreBadgeButton
            type="button"
            aria-label={appStoreBadgeLabel}
            onClick={onAppStoreBadgeClick}
            data-testid="app-download"
          >
            <AppStoreBadge />
          </S.AppStoreBadgeButton>
        ) : (
          <S.DownloadButton
            variant="dark"
            size="medium"
            to={oneLinkUrl ?? download.to}
            state={MULTI_PRODUCT_NAV_STATE}
            onClick={download.onClick}
            data-testid="app-download"
          >
            {download.label}
          </S.DownloadButton>
        )}
      </S.Content>
      {isQrPopupOpen && <AppQrPopup onClose={() => setIsQrPopupOpen(false)} />}
    </S.Container>
  )
}
